import "core-js/modules/es6.object.keys.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es7.object.entries.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function filterProductNodes(currentNode) {
  var objToKeep = ['images', 'generated_tcvars', 'prices', 'quantity_lot', 'reference', 'reference_encoded', 'translations'];
  var obj = false;

  if (objToKeep.indexOf(currentNode[0]) !== -1) {
    obj = true;
  }

  return obj;
}

function fetchProductList(_x, _x2) {
  return _fetchProductList.apply(this, arguments);
}

function _fetchProductList() {
  _fetchProductList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, payload) {
    var xhrUri, _yield$context$$axios, data, cNode, newData;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(context.getters['i18n/locale'].market, "/").concat(context.getters['i18n/locale'].language, "/layer-products/").concat(payload);
            _context.next = 3;
            return context.$axios.get(xhrUri);

          case 3:
            _yield$context$$axios = _context.sent;
            data = _yield$context$$axios.data;
            cNode = {};
            newData = Object.entries(data).reduce(function (prev, cur) {
              var curVal = Object.entries(cur[1]).filter(filterProductNodes).reduce(function (obj, item) {
                var newObj = obj; // eslint-disable-next-line

                newObj[item[0]] = item[1];
                return newObj;
              }, {}); // eslint-disable-next-line

              cNode[cur[0]] = curVal;
              return cNode;
            }, {});
            return _context.abrupt("return", Object.keys(newData));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchProductList.apply(this, arguments);
}

export { fetchProductList as default };